export const INJECTION_MODLING_KPI_LABELS = {
  totalModels: 'Total Models',
  completeModels: 'Completed Models',
  draftModels: 'Draft Models',
}
